import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default function TopRevenueAuctionsChart({ data }) {
  const hasData = data.length > 0;

  const chartData = {
    labels: data.map(item => item.propertyTitle), // Use propertyTitle as label
    datasets: [
      {
        label: "Total Revenue (£)",
        data: data.map(item => item.totalRevenue),
        backgroundColor: "rgba(255, 159, 64, 0.6)",
        borderColor: "rgba(255, 159, 64, 1)",
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => {
            return `Revenue: £${context.raw.toLocaleString()}`;
          },
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Property Title',
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Revenue (£)',
        },
        ticks: {
          callback: function (value) {
            return `£${value.toLocaleString()}`;  
          },
        },
      },
    },
  };

  return (
    <div className="chartCard">
      <h3>Top Revenue-Generating Auctions</h3>
      {hasData ? (
        <Bar data={chartData} options={chartOptions} />
      ) : (
        <p style={{ textAlign: "center", color: "#666" }}>
          No revenue data available
        </p>
      )}
    </div>
  );
}
